<template>
  <b-card class="card-accent-primary p-4" no-body>
    <b-card-body>
      <div v-if="isPending" id="form-loader">
        <Loading />
      </div>

      <b-form :style="{ opacity: isPending ? 0.5 : 1 }" @submit.prevent="onSubmit">
        <h1 class="mb-3"><i class="fa fa-unlock-alt me-1" /> {{ $t("Activate account") }}</h1>

        <p class="text-muted">
          {{ $t("To activate your account, please set your password.") }}
        </p>

        <b-input-group class="mb-3">
          <div class="input-group-text">
            <i class="fa fa-key" />
          </div>

          <b-form-input
            v-model="form.password"
            :disabled="isPending"
            :placeholder="$t('Password')"
            class="form-control"
            required
            type="password"
            autofocus
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <div class="input-group-text">
            <i class="fa fa-key" />
          </div>

          <b-form-input
            v-model="form.passwordConfirmation"
            :disabled="isPending"
            :placeholder="$t('Repeat password')"
            class="form-control"
            required
            type="password"
          />
        </b-input-group>

        <b-row>
          <b-col class="d-flex justify-content-between" sm="12">
            <b-button :to="{ name: 'auth.login' }" variant="secondary">
              <i class="fa fa-arrow-left me-1"></i> {{ $t("Back to login") }}
            </b-button>

            <b-button :disabled="isPending" type="submit" variant="primary">
              <i class="fa fa-unlock me-1" /> {{ $t("Activate") }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script lang="ts" setup>
import { useShowNotification } from "@/composables/showNotification.ts";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { usePostActivateGlobalUser } from "@generated/auth/query/auth.ts";
import { useRoute, useRouter } from "vue-router";
import Loading from "@/components/Loading.vue";

const router = useRouter();
const { t } = useI18n();
const { showNotification } = useShowNotification();
const { mutateAsync, isPending } = usePostActivateGlobalUser();
const { params } = useRoute();

const form = ref({
  password: "",
  passwordConfirmation: "",
});

const onSubmit = async () => {
  await mutateAsync({
    token: params.token as string,
    data: {
      password: form.value.password,
      passwordConfirmation: form.value.passwordConfirmation,
    },
  });

  showNotification({
    type: "success",
    text: t("Account has been activated. You can log in using your new password now."),
  });

  await router.push({ name: "auth.login" });
};
</script>

<style scoped>
#form-loader {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  top: 50%;
}
</style>
